import React from 'react'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LoyaltyTierPill from 'components/Luxkit/LoyaltyTierPill'
import TextLink from 'components/Luxkit/TextLink'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import TriplePointTakeoverLogo from './TriplePointTakeoverLogo'
import BodyText from 'components/Luxkit/Typography/BodyText'
import styled from 'styled-components'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'

const Span = styled.div`
  display: inline-grid;
  grid-template: 1ex / auto;
  place-items: center;
  vertical-align: middle;
  overflow: visible;
`

function TriplePointTakeoverSearchBanner() {
  const [tier] = useCurrentLoyaltyTier()
  return <Group direction="horizontal" gap={20} verticalAlign="center">
    <CSSBreakpoint min="tablet"><TriplePointTakeoverLogo size="medium" /></CSSBreakpoint>
    <VerticalSpacer gap={2}>
      <Heading variant="heading3">Your next trip just got <i>3x</i> better</Heading>
      <BodyText variant="large">
        Look for <Span><LoyaltyTierPill variant="primary" tier={tier}>Triple Points</LoyaltyTierPill></Span>{' '}
        on select packages! Hurry, limited time only. <TextLink to="/triple-points">View all offers</TextLink>
      </BodyText>
    </VerticalSpacer>
  </Group>
}

export default TriplePointTakeoverSearchBanner
